// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3IgkF","colCheckbox":"styles_colCheckbox__2v_zD"};